<template>
  <div class="card mx-auto">
    <div class="card-body">
      <h1 class="card-title">
        Error 404
      </h1>
      <p class="card-text">
        Oops! That page can&apos;t be found.
      </p>
    </div>
  </div>
</template>
